export default "__VITE_ASSET__CS2HLbwN__"